import ArchivioEventi from './ArchivioEventi';

export default ArchivioEventi;
